import React, { useState, useEffect } from 'react';

const ImageGalleryEdit = ({ images, productName }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  // تابع برای گرفتن URL تصویر (اگر نیاز به پردازش خاصی داشته باشیم)
  const getImageUrl = (img) => {
  if (!img) return "";
  return img.preview;
};

  // تابع برای تغییر تصویر اصلی با کلیک روی thumbnail
  const handleThumbnailClick = (index) => {
    setSelectedImageIndex(index);
  };

  // تابع برای چرخش تصاویر (اختیاری)
  const handleNextImage = () => {
    setSelectedImageIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  const handlePrevImage = () => {
    setSelectedImageIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  // پاکسازی URLهای ایجاد شده برای File/Blob
  useEffect(() => {
    return () => {
      images.forEach((img) => {
        if (img instanceof File || img instanceof Blob) {
          URL.revokeObjectURL(getImageUrl(img));
        }
      });
    };
  }, [images]);

  // اگر تصویری وجود ندارد
  if (!images || images.length === 0) {
    return (
      <div className="rounded-xl overflow-hidden border border-gray-200 bg-gray-100 aspect-[4/3]">
        <div className="w-full h-full flex items-center justify-center text-gray-300">
          <svg
            className="w-20 h-20"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
      </div>
    );
  }

  const mainImageUrl = getImageUrl(images[selectedImageIndex]);

  return (
    <div>
      {/* تصویر اصلی با قابلیت کلیک برای تغییر */}
      <div className="rounded-xl overflow-hidden border border-gray-200 bg-gray-100 aspect-[4/3] relative">
        {mainImageUrl ? (
          <img
            src={mainImageUrl}
            alt={productName || "تصویر محصول"}
            className="w-full h-full object-cover cursor-pointer"
            onClick={() => {
              // اگر تصاویر بیشتری وجود دارد، به تصویر بعدی برو
              if (images.length > 1) handleNextImage();
            }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-300">
            <svg
              className="w-20 h-20"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        )}

        {/* دکمه‌های ناوبری (فقط وقتی بیش از یک تصویر وجود دارد) */}
        {images.length > 1 && (
          <>
            <button
              onClick={handleNextImage}
              className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md transition-all"
              aria-label="تصویر قبلی"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              onClick={handlePrevImage}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md transition-all"
              aria-label="تصویر بعدی"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </>
        )}
      </div>

      {/* ردیف تصاویر کوچک (thumbnails) */}
      {images.length > 1 && (
        <div className="flex justify-end gap-3 mt-4">
          {images.slice(0, 6).map((img, index) => (
            <div
              key={index}
              className={`w-20 h-20 rounded-lg overflow-hidden border-2 cursor-pointer transition-all ${
                selectedImageIndex === index 
                  ? 'border-blue-500 scale-105' 
                  : 'border-gray-200 hover:border-gray-300'
              }`}
              onClick={() => handleThumbnailClick(index)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleThumbnailClick(index);
                }
              }}
            >
              <img
                src={img.preview}
                alt={`thumbnail-${index + 1}`}
                className="w-full h-full object-cover"
              />

              {/* نشانگر تصویر انتخاب شده */}
              {selectedImageIndex === index && (
                <div className="absolute top-1 right-1 w-2 h-2 bg-blue-500 rounded-full"></div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageGalleryEdit;